import React, { useState } from 'react';
import {
  Button,
  Container,
  TextField,
  Table,
  Modal,
  TableBody,
  TableCell,
  Box,
  Typography,
  TableContainer,
  IconButton,
  TableHead,
  TableRow,
  Paper,
  InputAdornment,
  Stack,
  FormControl,
  InputLabel,
  MenuItem,
  styled,
  Select,
  Tooltip,
  useTheme,
} from '@mui/material';
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
} from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import CloseIcon from '@mui/icons-material/Close';
import ChevronLeft from '@mui/icons-material/KeyboardDoubleArrowLeft';
import ChevronRight from '@mui/icons-material/KeyboardDoubleArrowRight';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
const CustomTableScrollbar = styled('div')(({ theme }) => ({
  '&::-webkit-scrollbar': {
    height: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'} transparent`,
}));

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Category = () => {
  const theme = useTheme();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showUserGuideModal,setShowUserGuideModal]=useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [searchTerm, setSearchTerm] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
  const [showEditCategoryModal, setShowEditCategoryModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState({ categoryId: null, categoryName: '' });
  const [categoryName, setCategoryName] = useState('');

  // Static data for categories
  const staticCategoryData = [
    { categoryId: 1, categoryName: 'Electronics' },
    { categoryId: 2, categoryName: 'Clothing' },
    { categoryId: 3, categoryName: 'Books' },
    { categoryId: 4, categoryName: 'Furniture' },
    { categoryId: 5, categoryName: 'Groceries' },
  ];

  // Handlers
  const handleEdit = (category) => {
    setSelectedCategory(category);
    setCategoryName(category.categoryName);
    setShowEditCategoryModal(true);
  };

  const handleDelete = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleAddCategory = () => setShowAddCategoryModal(true);

  const handleSave = (e) => {
    e.preventDefault();
    if (categoryName) {
      setSnackbarMessage('Category Added Successfully');
      setOpenSnackbar(true);
      setSnackbarSeverity('success')
      setShowAddCategoryModal(false);
      setCategoryName('');
    } else {
      setSnackbarMessage('plz enterd cateogroy name!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("error");
    }
  };

  const handleUpdate = () => {
    if (categoryName) {
      setSnackbarMessage('Category Updated Successfully');
      setOpenSnackbar(true);
      setShowEditCategoryModal(false);
    } else {
      alert('Please enter a category name');
    }
  };

  const handleReset = () => setCategoryName('');

  const handleCancel = () => {
    setShowEditCategoryModal(false);
    setCategoryName('');
  };

  // Filter and paginate data
  const filteredData = staticCategoryData.filter((category) =>
    category.categoryName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <Container>
      {/* Search and Add Button */}
      <Box sx={{ display: 'flex',justifyContent:'space-between', alignItems: 'center', mb: 1, p: 2 }}>
        {/* <TextField
          variant="outlined"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{ width: 300, maxWidth: '100%' }}
        /> */}
        <Box sx={{display:'flex',justifyContent:'center',alignItems:'center',gap:2}}>
        <TextField
                           variant="outlined"
                           placeholder="Search..."
                           value={searchTerm}
                           onChange={(e) => setSearchTerm(e.target.value)}
                           InputProps={{
                             startAdornment: (
                               <InputAdornment position="start">
                                 <SearchIcon
                                   sx={{
                                     color: theme.palette.primary.main,
                                     marginLeft: 1.5,
                                     fontSize: 24,
                                   }}
                                 />
                               </InputAdornment>
                             ),
                             endAdornment: searchTerm && (
                               <InputAdornment position="end">
                                 <IconButton
                                   size="small"
                                   onClick={() => setSearchTerm('')}
                                   sx={{
                                     color: "grey",
                                     marginRight: 1,
                                   }}
                                 >
                                   <CloseIcon fontSize="small" />
                                 </IconButton>
                               </InputAdornment>
                             ),
                             sx: {
                               borderRadius: '30px',
                               backgroundColor: theme.palette.mode === 'dark'
                                 ? 'rgba(255, 255, 255, 0.15)'
                                 : 'rgba(255, 255, 255, 1)',
                               boxShadow: theme.palette.mode === 'dark'
                                 ? '0 2px 8px rgba(0, 0, 0, 0.3)'
                                 : '0 2px 8px rgba(0, 0, 0, 0.1)',
                               '& .MuiOutlinedInput-notchedOutline': {
                                 border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
                               },
                               '&:hover': {
                                 backgroundColor: theme.palette.mode === 'dark'
                                   ? 'rgba(255, 255, 255, 0.2)'
                                   : 'rgba(240, 240, 240, 1)',
                                 boxShadow: theme.palette.mode === 'dark'
                                   ? '0 2px 12px rgba(0, 0, 0, 0.4)'
                                   : '0 2px 12px rgba(0, 0, 0, 0.15)',
                               },
                               '&.Mui-focused': {
                                 backgroundColor: theme.palette.mode === 'dark'
                                   ? 'rgba(255, 255, 255, 0.25)'
                                   : 'rgba(255, 255, 255, 1)',
                                 boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
                                 '& .MuiOutlinedInput-notchedOutline': {
                                   border: `2px solid ${theme.palette.primary.main}`,
                                 },
                               },
                               paddingLeft: 1.5,
                               height: '50px',
                               transition: 'all 0.3s ease',
                             },
                           }}
                           sx={{
                             width: 350,
                             maxWidth: '100%',
                             '& .MuiInputBase-input': {
                               padding: '10px 14px',
                               color: theme.palette.text.primary,
                               fontWeight: 500,
                             },
                           }}
                         />
        <Button
          variant="contained"
          onClick={handleAddCategory}
          sx={{
            ml: 2,
            width: "150px",
            height: "50px",
            padding: "10px 0",
            fontWeight: 'bold',
            borderRadius: '10px',
            backgroundColor: theme.palette.primary.main,
            '&:hover': { backgroundColor: theme.palette.primary.dark },
          }}
          startIcon={<AddIcon />}
        >
          ADD CATEGORY
        </Button>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            mb: 2,
          }}
        >
          <IconButton
            onClick={() => setShowUserGuideModal(true)}
            sx={{
              width: 60,
              height: 60,
              borderRadius: '50%',
              minWidth: 0, // Remove MUI's default padding
            }}
          >
            <InfoOutlineIcon sx={{ fontSize: 30 }} />
          </IconButton>
        </Box>
      </Box>

      {/* Table */}
      <Paper elevation={3} sx={{ paddingBottom: 0, maxWidth: '100%', boxSizing: 'border-box', mx: 'auto', backgroundColor: theme.palette.background.paper, borderRadius: '16px' }}>
        <CustomTableScrollbar sx={{ width: '100%', overflowX: 'hidden', borderRadius: '16px' }}>
          <TableContainer>
            <Table sx={{
              width: '100%',
              tableLayout: 'fixed',
              '& .MuiTableHead-root .MuiTableCell-root': {
                fontWeight: 'bold',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              },
            }}>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>S.No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Category Name</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bold', backgroundColor: theme.palette.primary.dark, fontSize: '1.1rem' }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((category, index) => (
                    <TableRow
                      key={category.categoryId}
                      sx={{
                        backgroundColor: index % 2 === 0 ? theme.palette.background.paper : theme.palette.background.paper,
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                      }}
                    >
                      <TableCell sx={{ fontSize: '1rem' }}>{(page - 1) * rowsPerPage + index + 1}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{category.categoryName}</TableCell>
                      <TableCell align="center">
                        <IconButton
                          onClick={() => handleEdit(category)}
                          sx={{
                            color: theme.palette.primary.light,
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          color="error"
                          onClick={() => handleDelete(category.categoryId, category.categoryName)}
                          sx={{
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow
                    sx={{
                      backgroundColor: theme.palette.background.paper,
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                      },
                    }}
                  >
                    <TableCell colSpan={3} align="center" sx={{ fontSize: '1rem', padding: '20px', wordSpacing: 7 }}>
                      No Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTableScrollbar>
      </Paper>

      {/* Pagination */}
      {filteredData.length > 0 && (
        <Box
          sx={{
            maxWidth: '100%',
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 1,
            p: 2,
            mx: 'auto',
            pt: 2,
          }}
        >
          <Typography variant="body2" color={theme.palette.primary.main}>
            Page <strong>{page}</strong> of <strong>{Math.ceil(filteredData.length / rowsPerPage)}</strong>
          </Typography>
          <Stack direction="row" alignItems="center" spacing={1}>
            <IconButton
              onClick={() => handleChangePage(null, page - 1)}
              disabled={page === 1}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': { backgroundColor: theme.palette.action.hover },
                '&.Mui-disabled': { opacity: 0.3 },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronLeft />
            </IconButton>
            {[...Array(Math.ceil(filteredData.length / rowsPerPage))].map((_, index) => (
              <IconButton
                key={index + 1}
                onClick={() => handleChangePage(null, index + 1)}
                sx={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  backgroundColor: page === index + 1 ? theme.palette.primary.main : 'transparent',
                  color: page === index + 1 ? theme.palette.primary.contrastText : theme.palette.text.primary,
                  '&:hover': {
                    backgroundColor: page === index + 1 ? theme.palette.primary.dark : theme.palette.action.hover,
                  },
                }}
              >
                {index + 1}
              </IconButton>
            ))}
            <IconButton
              onClick={() => handleChangePage(null, page + 1)}
              disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': { backgroundColor: theme.palette.action.hover },
                '&.Mui-disabled': { opacity: 0.3 },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronRight />
            </IconButton>
            <FormControl size="small" sx={{ minWidth: 100, ml: 1 }}>
              <InputLabel id="rows-per-page-label" sx={{ color: theme.palette.text.primary }}>Rows</InputLabel>
              <Select
                labelId="rows-per-page-label"
                value={rowsPerPage}
                onChange={(e) => {
                  const newRowsPerPage = Number(e.target.value);
                  setRowsPerPage(newRowsPerPage);
                  handleChangePage(null, 1);
                }}
                label="Rows"
                sx={{
                  height: '36px',
                  color: theme.palette.text.primary,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={30}>30</MenuItem>
              </Select>
            </FormControl>
          </Stack>
        </Box>
      )}

      {/* Snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* Delete Modal */}
      <Modal open={showDeleteModal} onClose={handleCloseDeleteModal} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px' }}>
            <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Delete Confirmation ⚠️
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="delete-modal-description" sx={{ mb: 2 }}>
              Are you sure you want to delete it?
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button onClick={handleCloseDeleteModal} variant="outlined" sx={{ mr: 1 }} data-app-cancel="true">
                Cancel
              </Button>
              <Button variant="contained" color="error" onClick={handleCloseDeleteModal}>
                Yes, Delete
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Add Category Modal */}
      <Modal open={showAddCategoryModal} onClose={() => setShowAddCategoryModal(false)} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Add Category
            </Typography>
            <IconButton onClick={() => setShowAddCategoryModal(false)} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <TextField
              label="Category Name"
              variant="outlined"
              fullWidth
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                }
              }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip title={!categoryName && "Enter Category Name"} arrow>
                <Button
                  variant="contained"
                  onClick={handleSave}
                  sx={{
                    mr: 2,
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': { backgroundColor: theme.palette.primary.dark }
                  }}
                  disabled={!categoryName}
                >
                  SAVE
                </Button>
              </Tooltip>
              <Button
                variant="contained"
                color="error"
                onClick={handleReset}
              >
                RESET
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Edit Category Modal */}
      <Modal open={showEditCategoryModal} onClose={handleCancel} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Edit Category
            </Typography>
            <IconButton onClick={handleCancel} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <TextField
              label="Category Name"
              variant="outlined"
              fullWidth
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                }
              }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip title={!categoryName && "Enter Category Name"} arrow>
                <Button
                  variant="contained"
                  onClick={handleUpdate}
                  sx={{
                    mr: 2,
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': { backgroundColor: theme.palette.primary.dark }
                  }}
                  disabled={!categoryName}
                >
                  UPDATE
                </Button>
              </Tooltip>
              <Button
                variant="contained"
                color="error"
                onClick={handleCancel}
              >
                CANCEL
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal
  open={showUserGuideModal}
  onClose={() => setShowUserGuideModal(false)}
  BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 800,
      bgcolor: 'background.paper',
      borderRadius: '16px',
      boxShadow: 24,
      overflow: 'hidden',
    }}
  >
    {/* Header */}
    <Box
      sx={{
        backgroundColor: theme.palette.primary.main,
        padding: '12px 16px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
        Category Management - User Guide
      </Typography>
      <IconButton
        onClick={() => setShowUserGuideModal(false)}
        sx={{ color: '#fff', position: 'absolute', right: 14 }}
      >
        <CloseIcon />
      </IconButton>
    </Box>

    {/* Scrollable Content */}
    <CustomTableScrollbar sx={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px' }}>
      {/* Section 1: Overview */}
      <Typography
        variant="body1"
        sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}
      >
        ➤ Overview of Category Management:
      </Typography>
      <ul
        style={{
          marginLeft: '20px',
          lineHeight: '1.8',
          cursor: 'pointer',
        }}
      >
        <li>
          View, search, add, edit, and delete categories in the table.
        </li>
        <li>
          Table displays S.No, Category Name, and Action column with Edit (blue pencil) and Delete (red trash) icons.
        </li>
        <li>
          Static demo data; integrates with backend in live application.
        </li>
      </ul>
      <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
        ⚠️ Note: All operations show success snackbars; no actual persistence in demo mode.
      </Typography>

      {/* Section 2: Search Categories */}
      <Typography
        variant="body1"
        sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
      >
        ➤ Follow these steps to search categories:
      </Typography>
      <ul
        style={{
          marginLeft: '20px',
          lineHeight: '1.8',
          cursor: 'pointer',
        }}
      >
        <li>
          Use the search field at the top-left labeled "Search by Category Name".
        </li>
        <li>
          Enter partial or full category name (case-insensitive search).
        </li>
        <li>
          Table filters instantly and pagination updates accordingly.
        </li>
        <li>
          Clear the search field to show all categories again.
        </li>
      </ul>
      <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
        ⚠️ Note: No results display "No Data Found" message in the table.
      </Typography>

      {/* Section 3: Add New Category */}
      <Typography
        variant="body1"
        sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
      >
        ➤ Follow these steps to add a new category:
      </Typography>
      <ul
        style={{
          marginLeft: '20px',
          lineHeight: '1.8',
          cursor: 'pointer',
        }}
      >
        <li>
          Click the <strong>"ADD CATEGORY"</strong> button (green + icon) next to search field.
        </li>
        <li>
          "Add Category" modal opens with Category Name text field.
        </li>
        <li>
          Enter the category name (required field).
        </li>
        <li>
          Click <strong>"SAVE"</strong> button (enabled only when name is entered).
        </li>
        <li>
          Success snackbar confirms addition; modal closes automatically.
        </li>
        <li>
          Use <strong>"RESET"</strong> button to clear field, or close icon/top-right X to cancel.
        </li>
      </ul>
      <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
        ⚠️ Note: SAVE button disabled with tooltip until Category Name is filled.
      </Typography>

      {/* Section 4: Edit Category */}
      <Typography
        variant="body1"
        sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
      >
        ➤ Follow these steps to update a category:
      </Typography>
      <ul
        style={{
          marginLeft: '20px',
          lineHeight: '1.8',
          cursor: 'pointer',
        }}
      >
        <li>
          Click the <strong>Edit icon</strong> (blue pencil) in the Action column of desired category row.
        </li>
        <li>
          "Edit Category" modal opens with pre-filled current category name.
        </li>
        <li>
          Modify the category name as needed.
        </li>
        <li>
          Click <strong>"UPDATE"</strong> button to save changes.
        </li>
        <li>
          Success snackbar confirms update; modal closes.
        </li>
        <li>
          Use <strong>"CANCEL"</strong> button or close icon to discard changes.
        </li>
      </ul>
      <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
        ⚠️ Note: UPDATE button disabled if Category Name field is empty.
      </Typography>

      {/* Section 5: Delete Category */}
      <Typography
        variant="body1"
        sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
      >
        ➤ Follow these steps to delete a category:
      </Typography>
      <ul
        style={{
          marginLeft: '20px',
          lineHeight: '1.8',
          cursor: 'pointer',
        }}
      >
        <li>
          Click the <strong>Delete icon</strong> (red trash) in the Action column.
        </li>
        <li>
          Confirmation modal appears:and ask to you about "Delete Confirmation".
        </li>
        <li>
          Modal asks "Are you sure you want to delete it?".
        </li>
        <li>
          Click <strong>"Yes, Delete"</strong> to confirm (demo: closes modal; live: removes record).
        </li>
        <li>
          Click <strong>"Cancel"</strong>button to stop deletion.
        </li>
      </ul>
      <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
        ⚠️ Note: Deletion irreversible in live app; proceed with caution. Demo shows snackbar but no actual removal.
      </Typography>

      {/* Section 6: Pagination */}
      <Typography
        variant="body1"
        sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
      >
        ➤ Follow these steps to navigate categories:
      </Typography>
      <ul
        style={{
          marginLeft: '20px',
          lineHeight: '1.8',
          cursor: 'pointer',
        }}
      >
        <li>
          Use pagination controls at bottom: left/right arrows, page numbers, rows dropdown.
        </li>
        <li>
          Rows options: 5, 10, 20, 30 per page.
        </li>
        <li>
          Pagination applies to filtered search results.
        </li>
      </ul>
      <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
        ⚠️ Note: Pagination hidden when no data or no search results.
      </Typography>

      {/* Section 7: Feedback & Notifications */}
      <Typography
        variant="body1"
        sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
      >
        ➤ Feedback and notifications:
      </Typography>
      <ul
        style={{
          marginLeft: '20px',
          lineHeight: '1.8',
          cursor: 'pointer',
        }}
      >
        <li>
          Successful add/edit shows green snackbar at top-center.
        </li>
        <li>
          Empty field validation uses browser alert() in demo.
        </li>
        <li>
          Table rows alternate colors, hover effect for better UX.
        </li>
      </ul>
      <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
        ⚠️ Note: Enhance error handling with snackbars in production; add backend validation.
      </Typography>

      {/* Bottom Close */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
      </Box>
    </CustomTableScrollbar>
  </Box>
</Modal>
<Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default Category;
